module.exports = __webpack_public_path__ + "static/media/noBurningPendant.db2528ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/noBurningPendant.png
// module id = 992
// module chunks = 0